<template>
    <div>
        <!-- Facebook Fanpage -->
        <div class="mt-0 a-announce">
            <iframe 
                class="mt-0"
                ref="divFanpage"
                :src="urlFacebook" 
                style="border:none;overflow:hidden;width:100%;height:800px;" 
                scrolling="no" 
                frameborder="0" 
                allowTransparency="true" 
                allow="encrypted-media"
            ></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            MaxScale:String,
        },
        data() {
            return {
                urlFacebook:0
            }
        },
        mounted(){
            this.setElUrl()
        },
        methods: {
            setElUrl(){
                this.urlFacebook = `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmuicnews%2F&tabs=timeline&width=${this.$refs['divFanpage'].clientWidth > 500 ? 500 : this.$refs['divFanpage'].clientWidth}&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
            },
        }
    }
</script>

<style lang="scss" scoped>
    .font-card-head{ font-family: 'Baloo Tamma 2', cursive; }
    .color-head-f{ color: #452b73; font-weight: 700; }
    .font-anount{ font-family: 'Baloo Tamma 2', cursive; }
    .card-announ{
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        // border-radius: 20px;
    }
    .bg-light-custom { background-color: #ffffff !important; }
    .font-anoun-detail{ font-family: 'Baloo Tamma 2', cursive !important; }
    .font-anoun-footer{ font-size: 0.7rem; }
    .text-purple{ color: #452b73  }
    .a-announce{
        color: #1b1e21;
        background-color: #fbf6f6;
        border-color: #ffffff00;
        padding: 17px;
        border-radius: 20px;
    }
</style>